const QaisTab = ({ data, menus, selected, changeMenu }) => {

  function renderingBar(step) {
    let iClass = "bars bars" + step;
    const result = [];
    for (let i = 0; i < 5; i++) {
      result.push(
        <i key={i} className={i < step ? 'full': ''}></i>
      );
    }

    return (
      <div className={iClass}>
        {result}
      </div>
    )
  }

  function renderingButton(item, index) {
    let step;
    if (item.value === 'G') {
      step = data.GROWTH_STEP;
    } else if (item.value === 'V') {
      step = data.VALUE_STEP;
    } else if (item.value === 'M') {
      step = data.MOMENTUM_STEP;
    } else if (item.value === 'S') {
      step = data.STABILITY_STEP;
    } else if (item.value === 'P') {
      step = data.PERFORMANCE_STEP;
    }

    let tabColor;
    if (step === 1) {
      tabColor = 'tab_red';
    } else if (step === 2) {
      tabColor = 'tab_orange';
    } else if (step === 3) {
      tabColor = 'tab_yellow';
    } else if (step === 4) {
      tabColor = 'tab_green';
    } else if (step === 5) {
      tabColor = 'tab_darkgreen';
    }

    let selectedClass = '';
    if (item.value === selected.value) {
      selectedClass = 'selected';
    }

    return (
      <button
        key={index}
        className={"tab " + tabColor + " " + selectedClass}
        onClick={(e) => {
          e.preventDefault();
          changeMenu(item);
        }}
      >
        <div className="tit">{item.label}</div>
        {renderingBar(step)}
      </button>
    )
  }

	return (
    <div className="tabs">
      { menus.map((item, index) => {
          return renderingButton(item, index)
        })
      }
    </div>
  );
}

export default QaisTab;
